import React from 'react'

import App from '../Components/App'

const Main = () => <App />

export default Main
